import React from 'react'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'
import Grid from '@mui/material/Grid'

const HeartRate = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      type="number"
      value={value}
      onChange={onChange}
      label="Heart Rate"
      InputProps={{
        endAdornment: 'bpm',
        inputProps: { min: 0, max: 1000, step: 'any' },
      }}
    />
  </Grid>
)

export default HeartRate
